import type { CompletionResult } from '@codemirror/autocomplete';
import { CompletionContext } from '@codemirror/autocomplete';

import type { ListAutocompletionConfig } from './list-autocompletion-types.js';
import { listAutocompletion } from './list-autocompletion.js';
import type { IntlProps } from '../../utils/render-node.js';
import { autocompletionExtension } from '../autocompletion.extension.js';

export const listAutocompletionExtension = (
  listAutoCompletionConfig: ListAutocompletionConfig,
  intlProps: IntlProps,
): ((ctx: CompletionContext) => Promise<CompletionResult | null>) => {
  return autocompletionExtension(
    listAutocompletion(listAutoCompletionConfig),
    intlProps,
  );
};
